export const groupDigits = (n) => String(Math.round(Math.abs(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
export const euro = (n) => `€ ${groupDigits(n)}`;
